const CSS = () => `
    html.locked,
    html.locked body {
        overflow: hidden;
    }
`;

let { scrollY } = window;
let { wheelY } = 0;

function preventTouchMove (e) {
    e.stopPropagation();

    if (e.target.closest('[data-scrollable], .site-scrollable')) return;

    e.preventDefault();
}

function preventKeyScroll (e) {
    const keys = [33, 34, 35, 36, 37, 38, 39, 40];

    if (keys.includes(e.keyCode)) e.preventDefault();
}

function preventScroll (e) {
    window.scrollTo(0, scrollY);

    e.preventDefault();
}

function handleWheel (e) {
    const element = e.target.closest('[data-scrollable], .site-scrollable');
    if (!element) return;

    wheelY += e.deltaY * 0.25;

    element.scrollTop = wheelY;
}

function disableScrolling (element) {
    element.classList.add('locked');

    scrollY = window.scrollY;

    element.addEventListener('touchmove', preventTouchMove, { passive: false });

    window.addEventListener('scroll', preventScroll, { passive: false });
    window.addEventListener('keydown', preventKeyScroll, { passive: false });

    window.addEventListener('wheel', handleWheel, { passive: false });

    if (window.lenis) window.lenis.stop();
}

function enableScrolling (element) {
    element.classList.remove('locked');

    element.removeEventListener('touchmove', preventTouchMove);

    window.removeEventListener('scroll', preventScroll);
    window.removeEventListener('keydown', preventKeyScroll);

    window.removeEventListener('wheel', handleWheel);

    wheelY = 0;

    if (window.lenis) window.lenis.start();
}

/**
 * This feature is used to disable and enable scrolling
 * 
 * @class Scrolling
 */
export default class Scrolling {
    constructor () {
        if (!document.documentElement) {
            throw new Error('Document element does not exist');
        }

        this.document = document.documentElement;

        const head = document.head || document.querySelector('head');
        this.head = head || null;

        this.setStyles();
    }

    setStyles () {
        if (!this.head) return;

        const style = document.createElement('style');
        style.setAttribute('id', 'site-scrolling-css');
        style.type = 'text/css';

        if (style.styleSheet) {
            style.styleSheet.cssText = CSS();
        } else {
            style.appendChild(document.createTextNode(CSS()));
        }

        this.head.append(style);
    }

    disable () {
        disableScrolling(this.document);
    }

    enable () {
        enableScrolling(this.document);
    }
}
